import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { BookDemoDialogComponent } from '../dialogs/book-demo-dialog/book-demo-dialog.component';
import { BookDemoService } from '../dialogs/book-demo-dialog/book-demo.service';

@Component({
  selector: 'app-book-demo-page',
  templateUrl: './book-demo-page.component.html',
  styleUrls: ['./book-demo-page.component.scss'],
})
export class BookDemoPageComponent implements OnInit, OnDestroy {
  private dialogRef?: MatDialogRef<BookDemoDialogComponent>;
  private closeSub?: Subscription;

  constructor(
    private bookDemo: BookDemoService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.openDialog();
    }
  }

  ngOnDestroy(): void {
    this.closeSub?.unsubscribe();
    this.dialogRef?.close();
  }

  openDialog(): void {
    if (this.dialogRef) return;
    this.dialogRef = this.bookDemo.open();
    this.closeSub = this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = undefined;
    });
  }
}
